var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12.5 22a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19zm0-2a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm0-13.5a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm0 9.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"}));
}

Warning.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = Warning;

Warning.default = Warning;
